import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=cd3a424c&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "styles/components/bottomfooter.css?vue&type=style&index=0&id=cd3a424c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3a424c",
  null
  
)

export default component.exports